import { getAccessToken } from "../../services/authService"

// Loads a script's scenes from the scene headings saved in the script itself (the same
// headings the editor's Scenes panel reads). Read-only: never changes the script.
export const loadScriptScenes = async (scriptId) => {
  const token = getAccessToken()
  if (!token) throw new Error("A valid session not found")
  const response = await fetch(`${process.env.REACT_APP_DEV_API}/document/${encodeURIComponent(scriptId)}`, {
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
  })
  if (!response.ok) throw new Error("Could not load scenes")
  const body = await response.json()
  const html = body?.data?.content || ""
  const doc = new DOMParser().parseFromString(html, "text/html")
  return Array.from(doc.querySelectorAll(".sceneHeadings"))
    .map((node, index) => ({ id: `${index + 1}`, index: index + 1, heading: (node.textContent || "").replace(/\s+/g, " ").trim() }))
    .filter((scene) => scene.heading)
    .map((scene, i) => ({ ...scene, index: i + 1, id: `${i + 1}` }))
}
